<style lang="scss">
    .noUi-connect,
    .noUi-horizontal .noUi-handle {
        background-color: #ff5855;
    }

    .noUi-horizontal .noUi-handle.noUi-active, 
    .noUi-vertical .noUi-handle.noUi-active {
        box-shadow: 0px 0px 0px 2px #ff5855!important;
    }

    .input-slider {
        margin-right: -15px;
        margin-left: -15px;
    }
</style>

<script>
import BaseSlider from "@/components/BaseSlider";

export default {
    name: "resimple-slider",
    extends: BaseSlider,
    props: {
        interval: {
            type: Number,
            default: 10,
            description: "Intervalo"
        }
    },
    watch: {
        value(value) {
            let newValue = 0;
            var newStep = Math.round(value / this.interval);

            if (value > this.interval)
                newValue = newStep * this.interval;
            else if (value == 0)
                newValue = 0;
            else
                newValue = this.interval;

            this.$emit("input", newValue);
        }
    }
}
</script>